import React from "react";

import Hero from "../components/Hero";
import AboutUs from "../components/AboutSection";
import Fact from "../components/WhyChooseUs";
import Services from "../components/ServicesSection";
import WhyUs from "../components/WhyUsSection";
import CTAPage from "../components/CTAPage";
import ContactUs from "../components/ContactSection";

const HomePage = ({ isDarkMode }) => {
  const facts = [
    "Our team has over 20 years of combined experience.",
    "We’ve completed 100+ successful projects across various industries.",
    "We are committed to providing sustainable tech solutions.",
  ];

  return (
    <>
      <Hero isDarkMode={isDarkMode} />
      <AboutUs isDarkMode={isDarkMode} />
      <Fact isDarkMode={isDarkMode} facts={facts} />
      <Services isDarkMode={isDarkMode} />
      <WhyUs isDarkMode={isDarkMode} />
      <CTAPage isDarkMode={isDarkMode} />
      <ContactUs isDarkMode={isDarkMode} />
    </>
  );
};

export default HomePage;
